import styled from '@emotion/styled';
import { vars } from '@teamsparta/stack-tokens';

export const Button = styled.button<{ isActive?: boolean }>`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${({ isActive }) =>
    isActive ? vars.neutral[10] : 'transparent'};

  @media (hover: none) {
    &:active {
      background-color: ${({ isActive }) =>
        isActive ? vars.neutral[10] : vars.neutral[80]};
    }
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ isActive }) =>
        isActive ? vars.neutral[10] : vars.neutral[80]};
    }
  }

  transition: background-color 0.3s ease;
`;
